import { render, staticRenderFns } from "./asignacion-documental.vue?vue&type=template&id=2b752483&"
import script from "./asignacion-documental.component.ts?vue&type=script&lang=ts&"
export * from "./asignacion-documental.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports